import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import UserAppResource from './UserAppResource';
import WorkspaceAppResource from './WorkspaceAppResource';
import EmailCampaignAppResource from "./EmailCampaignAppResource";
import Engine from "@milestoneslabs/milestones-js-engine/src/Engine";
import LandingPageAppResource from "./LandingPageAppResource";
import moment from "moment";

class EmailCampaignUserAppResource extends AppResource {

  /**
   * @returns {string}
   */
  appResourceType() {
    return 'email-campaign-user';
  }

  /**
   * @returns {string}
   */
  appResourceApiPrefix() {
    return 'emails/campaigns/users';
  }

  /**
   * @returns {*[]}
   */
  hidden() {
    return super.hidden().concat([
      'uuid',
      'deleted_at',
    ]);
  }

  /**
   * @returns {*[]}
   */
  fillable() {
    return [
      'emailCampaignUuid',
      'userUuid',
      'hubUuid',
      'landingPageUuid',
      'meta',
      'disabledAt',
      'inactivePeriod',
      'inactiveCampaignPeriod',
    ];
  }

  /**
   * @returns {*[]}
   */
  relationMap() {
    return {
      campaigns: EmailCampaignAppResource,
      users: UserAppResource,
      hubs: WorkspaceAppResource,
      landingPage: LandingPageAppResource,
    };
  }

  /**
   * @returns {*[]}
   */
  relationForeignKeys() {
    return {
      campaigns: 'email_campaign_uuid',
      users: 'user_uuid',
      hubs: 'hub_uuid',
      landingPage: 'landing_page_uuid',
    };
  }

  /**
   * @returns {*}
   */
  validationRules() {
    return {
      emailCampaignUuid: {
        type: 'string',
        presence: true,
      },
      userUuid: {
        type: 'string',
      },
      hubUuid: {
        type: 'string',
      },
      landingPageUuid: {
        type: 'string',
      },
      inactivePeriod: {
        numericality: true,
      },
      inactiveCampaignPeriod: {
        numericality: true,
      },
      disabledAt:{

      }
    };
  }

  suppression(data = {}) {
    this.enginePost(
        this.apiPaths().suppression,
        data
    );
  }

  apiPaths(environment = null) {
      return {
          ...super.apiPaths(environment),
          'suppression': Engine.apiUrl(this.appResourceApiPrefix()) + '/suppression',
      }
  }

  get disabled() {
      return this.disabledAt ? true : false;
  }

  set disabled(value) {
      if (value) {
          this.setAttribute('disabledAt', moment().format("YYYY-MM-DD HH:mm:ss"));
          return;
      }
      this.setAttribute('disabledAt', null);
  }
}

export default EmailCampaignUserAppResource;
